"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CardContainer_component_exports = {};
__export(CardContainer_component_exports, {
  CardContainer: () => CardContainer,
  default: () => CardContainer_component_default
});
module.exports = __toCommonJS(CardContainer_component_exports);
var import_react = __toESM(require("react"));
var import_baseThemeTailwindcss = require("../../../../themes/baseThemeTailwindcss");
var import_useBreakpoints = require("../../../../utils/useBreakpoints/useBreakpoints.hook");
var import_CardContainer = require("./CardContainer.styled");
var import_CardHeader = require("../CardHeader/CardHeader.component");
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var _excluded = ["backgroundColor", "cardState", "children"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r))
    return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var CardContainer = function CardContainer2(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? "white" : _ref$backgroundColor, cardState = _ref.cardState, children = _ref.children, props = _objectWithoutProperties(_ref, _excluded);
  var breakpoints = (0, import_useBreakpoints.useBreakpoints)();
  var is400percent = breakpoints.isSm || breakpoints.isXs;
  var findCardHeader = function findCardHeader2(child) {
    return child.find(function(c) {
      return /* @__PURE__ */ (0, import_react.isValidElement)(c) && c.type === import_CardHeader.CardHeader;
    });
  };
  var childCloned = import_react.Children.map(children, function(child, i) {
    if (/* @__PURE__ */ (0, import_react.isValidElement)(child) && i === 0) {
      var roleProps = child.props.href ? {
        role: "presentation"
      } : {};
      var childrenArray = Array.isArray(child.props.children) ? child.props.children : [child.props.children];
      var cardHeaderElement = findCardHeader(childrenArray);
      if (!cardHeaderElement) {
        return /* @__PURE__ */ (0, import_react.cloneElement)(child, roleProps);
      }
      var cardHeaderUpdated = /* @__PURE__ */ (0, import_react.cloneElement)(cardHeaderElement, {
        key: "cardHeader-".concat(cardHeaderElement.props.id),
        cardState
      });
      return /* @__PURE__ */ (0, import_react.cloneElement)(child, _objectSpread(_objectSpread({}, roleProps), {}, {
        children: [cardHeaderUpdated].concat(_toConsumableArray(childrenArray.filter(function(c) {
          return c !== cardHeaderElement;
        })))
      }));
    }
    return child;
  });
  return /* @__PURE__ */ import_react.default.createElement(import_CardContainer.CardContainerStyled, _extends({
    backgroundColor,
    cardState,
    "data-testid": "card-container"
  }, props), /* @__PURE__ */ import_react.default.createElement(import_CardContainer.ContentLayout, {
    is400percent,
    numberOfChildren: childCloned === null || childCloned === void 0 ? void 0 : childCloned.length
  }, childCloned), cardState === "notification" ? /* @__PURE__ */ import_react.default.createElement(import_CardContainer.IconContainerStyled, null, /* @__PURE__ */ import_react.default.createElement(import_CardContainer.IconStyled, {
    color: import_baseThemeTailwindcss.baseThemeTailwindcss.theme.colors.n.white,
    icon: "bell-f"
  })) : null);
};
var CardContainer_component_default = CardContainer;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CardContainer
});
//# sourceMappingURL=CardContainer.component.js.map